export const vicQuotesData = [
  {
    "name": "Aberfeldie",
    "value": 1,
    "lat": -37.7596196,
    "lng": 144.8974571
  },
  {
    "name": "Agnes",
    "value": 1,
    "lat": -38.6396699,
    "lng": 146.3732259
  },
  {
    "name": "Aintree",
    "value": 13,
    "lat": -37.7193933,
    "lng": 144.6694023
  },
  {
    "name": "Airport West",
    "value": 1,
    "lat": -38.0952468,
    "lng": 146.9634381675828
  },
  {
    "name": "Albert Park",
    "value": 6,
    "lat": -37.8452062,
    "lng": 144.957105
  },
  {
    "name": "Alphington",
    "value": 3,
    "lat": -37.7783921,
    "lng": 145.0312833
  },
  {
    "name": "Altona",
    "value": 1,
    "lat": -37.867150300000006,
    "lng": 144.82946367934787
  },
  {
    "name": "Altona Meadows",
    "value": 1,
    "lat": -37.8814419,
    "lng": 144.7845482
  },
  {
    "name": "Altona North",
    "value": 1,
    "lat": -37.8671223,
    "lng": 144.8294793
  },
  {
    "name": "Apollo Bay",
    "value": 1,
    "lat": -38.7547442,
    "lng": 143.6691463
  },
  {
    "name": "Armadale",
    "value": 3,
    "lat": -37.8563442,
    "lng": 145.01932066100542
  },
  {
    "name": "Armstrong Creek",
    "value": 5,
    "lat": -38.2341184,
    "lng": 144.3709512
  },
  {
    "name": "Ascot Vale",
    "value": 4,
    "lat": -37.7753252,
    "lng": 144.921825
  },
  {
    "name": "Avondale Heights",
    "value": 2,
    "lat": -37.7614537,
    "lng": 144.862141
  },
  {
    "name": "Bacchus Marsh",
    "value": 1,
    "lat": -37.6751897,
    "lng": 144.4366202
  },
  {
    "name": "Badger Creek",
    "value": 1,
    "lat": -37.7015267,
    "lng": 145.5329174
  },
  {
    "name": "Ballarat",
    "value": 3,
    "lat": -37.5623013,
    "lng": 143.8605645
  },
  {
    "name": "Ballarat Central",
    "value": 2,
    "lat": -37.5627279,
    "lng": 143.8501516
  },
  {
    "name": "Ballarat/ Wendouree",
    "value": 1,
    "lat": -37.537055699999996,
    "lng": 143.83012005823903
  },
  {
    "name": "Bannockburn",
    "value": 2,
    "lat": -38.0443362,
    "lng": 144.1738367
  },
  {
    "name": "Barwon Heads",
    "value": 1,
    "lat": -38.2747705,
    "lng": 144.4881352
  },
  {
    "name": "Bayswater",
    "value": 2,
    "lat": -37.841739,
    "lng": 145.2681208
  },
  {
    "name": "Bayswater North",
    "value": 1,
    "lat": -37.8260474,
    "lng": 145.2819271
  },
  {
    "name": "Beaconsfield",
    "value": 1,
    "lat": -38.0510344,
    "lng": 145.36634205777816
  },
  {
    "name": "Bellfield",
    "value": 1,
    "lat": -37.7531065,
    "lng": 145.0384784
  },
  {
    "name": "Belmont",
    "value": 2,
    "lat": -38.1785947,
    "lng": 144.3421337
  },
  {
    "name": "Bentleigh East",
    "value": 1,
    "lat": -37.9220201,
    "lng": 145.0665529
  },
  {
    "name": "Berwick",
    "value": 23,
    "lat": -38.0259389,
    "lng": 145.31175423127402
  },
  {
    "name": "Beveridge",
    "value": 2,
    "lat": -37.4712651,
    "lng": 144.9745663
  },
  {
    "name": "Black Rock",
    "value": 1,
    "lat": -37.9706564,
    "lng": 145.0212822
  },
  {
    "name": "Bonbeach",
    "value": 1,
    "lat": -38.065449,
    "lng": 145.120108
  },
  {
    "name": "Box Hill",
    "value": 4,
    "lat": -37.8192487,
    "lng": 145.1221382
  },
  {
    "name": "Braeside",
    "value": 3,
    "lat": -38.0005245,
    "lng": 145.1229578
  },
  {
    "name": "Braybrook",
    "value": 2,
    "lat": -37.77744905,
    "lng": 144.8486197662329
  },
  {
    "name": "Brighton",
    "value": 12,
    "lat": -37.9081962,
    "lng": 144.9957991
  },
  {
    "name": "Brighton East",
    "value": 5,
    "lat": -37.9213636,
    "lng": 145.01850046991083
  },
  {
    "name": "Broadmeadows",
    "value": 7,
    "lat": -37.68305265,
    "lng": 144.91948587060236
  },
  {
    "name": "Brunswick",
    "value": 5,
    "lat": -37.7664715,
    "lng": 144.9613103
  },
  {
    "name": "Bulleen",
    "value": 9,
    "lat": -37.7688992,
    "lng": 145.0871992
  },
  {
    "name": "Bundoora",
    "value": 9,
    "lat": -37.6982468,
    "lng": 145.0596757
  },
  {
    "name": "Burnside",
    "value": 1,
    "lat": -37.749374,
    "lng": 144.753027
  },
  {
    "name": "Burwood",
    "value": 1,
    "lat": -37.849578,
    "lng": 145.1113915
  },
  {
    "name": "Burwood East",
    "value": 2,
    "lat": -33.87452745,
    "lng": 151.10590194588195
  },
  {
    "name": "COBBLEBANK",
    "value": 4,
    "lat": -37.7125512,
    "lng": 144.6040773
  },
  {
    "name": "Canterbury",
    "value": 5,
    "lat": -37.8247469,
    "lng": 145.0807636
  },
  {
    "name": "Carlton",
    "value": 9,
    "lat": -37.8004228,
    "lng": 144.9684343
  },
  {
    "name": "Carnegie",
    "value": 4,
    "lat": -37.88622945,
    "lng": 145.05856954596675
  },
  {
    "name": "Caroline Springs",
    "value": 6,
    "lat": -37.7340623,
    "lng": 144.7370017
  },
  {
    "name": "Caroline Srpings",
    "value": 1,
    "lat": -37.7340623,
    "lng": 144.7370017
  },
  {
    "name": "Carrum Downs",
    "value": 3,
    "lat": -38.1003312,
    "lng": 145.1788657
  },
  {
    "name": "Caulfield",
    "value": 1,
    "lat": -37.8775177,
    "lng": 145.0424939
  },
  {
    "name": "Caulfield North",
    "value": 3,
    "lat": -37.881841800000004,
    "lng": 145.0394290297183
  },
  {
    "name": "Caulfield South",
    "value": 1,
    "lat": -37.894699,
    "lng": 145.0249323
  },
  {
    "name": "Charlemont",
    "value": 2,
    "lat": -38.20975,
    "lng": 144.3686705
  },
  {
    "name": "Cheltenham",
    "value": 4,
    "lat": -37.9634181,
    "lng": 145.0615668
  },
  {
    "name": "Chirnside Park",
    "value": 1,
    "lat": -37.9047634,
    "lng": 144.6530423939503
  },
  {
    "name": "Clayton",
    "value": 14,
    "lat": -37.9158025,
    "lng": 145.1313859
  },
  {
    "name": "Clyde",
    "value": 3,
    "lat": -38.1326345,
    "lng": 145.3290375
  },
  {
    "name": "Clyde North",
    "value": 17,
    "lat": -38.1028681,
    "lng": 145.3302814
  },
  {
    "name": "Coburg",
    "value": 2,
    "lat": -37.7449752,
    "lng": 144.9643314
  },
  {
    "name": "Coolaroo",
    "value": 3,
    "lat": -37.6612428,
    "lng": 144.92603114027156
  },
  {
    "name": "Corio",
    "value": 5,
    "lat": -38.074088,
    "lng": 144.3586481
  },
  {
    "name": "Craigieburn",
    "value": 13,
    "lat": -37.6022613,
    "lng": 144.9430882
  },
  {
    "name": "Craigieburn Road",
    "value": 1,
    "lat": -37.59093369522165,
    "lng": 144.88723368307504
  },
  {
    "name": "Cranbourne",
    "value": 1,
    "lat": -38.0997308,
    "lng": 145.2807256
  },
  {
    "name": "Cranbourne West",
    "value": 7,
    "lat": -38.102241,
    "lng": 145.2517182
  },
  {
    "name": "Croydon",
    "value": 8,
    "lat": -37.7955004,
    "lng": 145.2801507
  },
  {
    "name": "Croydon Hills",
    "value": 1,
    "lat": -37.7743527,
    "lng": 145.2661042
  },
  {
    "name": "Dandenong",
    "value": 12,
    "lat": -37.9901275,
    "lng": 145.20982829306604
  },
  {
    "name": "Dandenong South",
    "value": 3,
    "lat": -38.0279936,
    "lng": 145.2209236
  },
  {
    "name": "Deanside",
    "value": 1,
    "lat": -37.729087,
    "lng": 144.704081
  },
  {
    "name": "Deer Park",
    "value": 1,
    "lat": -37.7686602,
    "lng": 144.7713077
  },
  {
    "name": "Derrimut",
    "value": 6,
    "lat": -37.7987978,
    "lng": 144.776051
  },
  {
    "name": "Devon Meadows",
    "value": 1,
    "lat": -38.1620178,
    "lng": 145.3024933
  },
  {
    "name": "Diamond Creek",
    "value": 1,
    "lat": -37.6733272,
    "lng": 145.1588075
  },
  {
    "name": "Diggers Rest",
    "value": 7,
    "lat": -37.6275995,
    "lng": 144.7200075
  },
  {
    "name": "Dingley Village",
    "value": 2,
    "lat": -37.9755762,
    "lng": 145.1256478
  },
  {
    "name": "Docklands",
    "value": 3,
    "lat": -37.8175423,
    "lng": 144.9394923
  },
  {
    "name": "Doncaster",
    "value": 7,
    "lat": -37.7848299,
    "lng": 145.1238431
  },
  {
    "name": "Donnybrook",
    "value": 15,
    "lat": -37.5419879,
    "lng": 144.9702272
  },
  {
    "name": "Donvale",
    "value": 2,
    "lat": -37.77243895,
    "lng": 145.18566726274176
  },
  {
    "name": "Dooen",
    "value": 1,
    "lat": -37.011142500000005,
    "lng": 145.8647546604073
  },
  {
    "name": "Dookie College",
    "value": 1,
    "lat": -36.3642532,
    "lng": 145.49150279959207
  },
  {
    "name": "Doreen",
    "value": 7,
    "lat": -37.5963874,
    "lng": 145.1428928
  },
  {
    "name": "Dromana",
    "value": 2,
    "lat": -38.3418285,
    "lng": 144.9655838
  },
  {
    "name": "Drouin",
    "value": 1,
    "lat": -38.1361683,
    "lng": 145.8564344
  },
  {
    "name": "Drysdale",
    "value": 5,
    "lat": -38.1728304,
    "lng": 144.5710723
  },
  {
    "name": "Eaglehawk",
    "value": 2,
    "lat": -36.7077015,
    "lng": 144.2632350826287
  },
  {
    "name": "East Geelong",
    "value": 1,
    "lat": -38.152805,
    "lng": 144.37404164244722
  },
  {
    "name": "East Melbourne",
    "value": 5,
    "lat": -37.819908999999996,
    "lng": 144.98322500667754
  },
  {
    "name": "Echuca",
    "value": 4,
    "lat": -36.1281405,
    "lng": 144.7516955
  },
  {
    "name": "Elwood",
    "value": 5,
    "lat": -37.8819945,
    "lng": 144.98538770441866
  },
  {
    "name": "Endeavour Hills",
    "value": 1,
    "lat": -37.9702665,
    "lng": 145.2563443
  },
  {
    "name": "Epping",
    "value": 18,
    "lat": -37.6523847,
    "lng": 145.0315487436747
  },
  {
    "name": "Epsom",
    "value": 1,
    "lat": -36.699897,
    "lng": 144.30901
  },
  {
    "name": "Essendon",
    "value": 6,
    "lat": -37.7560691,
    "lng": 144.9160228
  },
  {
    "name": "Essendon Fields",
    "value": 10,
    "lat": -37.72660985,
    "lng": 144.90131801511075
  },
  {
    "name": "Eynesbury",
    "value": 5,
    "lat": -37.7908381,
    "lng": 144.5561657
  },
  {
    "name": "Fairfield",
    "value": 3,
    "lat": -37.7791763,
    "lng": 145.0169241
  },
  {
    "name": "Ferntree Gully",
    "value": 2,
    "lat": -37.8815825,
    "lng": 145.2951466
  },
  {
    "name": "Fitzroy",
    "value": 1,
    "lat": -37.8010382,
    "lng": 144.9792611
  },
  {
    "name": "Fitzroy North",
    "value": 1,
    "lat": -37.78513865,
    "lng": 144.987826521994
  },
  {
    "name": "Flora Hill",
    "value": 1,
    "lat": -36.7781198,
    "lng": 144.2984448
  },
  {
    "name": "Footscray",
    "value": 13,
    "lat": -37.7981339,
    "lng": 144.897345
  },
  {
    "name": "Forest Hill",
    "value": 1,
    "lat": -37.8489562,
    "lng": 145.16237861533313
  },
  {
    "name": "Frankston",
    "value": 8,
    "lat": -38.1457064,
    "lng": 145.1263742
  },
  {
    "name": "Frankston North",
    "value": 2,
    "lat": -38.1228524,
    "lng": 145.1609788
  },
  {
    "name": "Fraser Rise",
    "value": 2,
    "lat": -37.7059863,
    "lng": 144.7174013
  },
  {
    "name": "Garfield",
    "value": 1,
    "lat": -38.0898677,
    "lng": 145.676222
  },
  {
    "name": "Geelong",
    "value": 18,
    "lat": -38.1493248,
    "lng": 144.3598241
  },
  {
    "name": "Gisborne",
    "value": 3,
    "lat": -37.486723,
    "lng": 144.5904237
  },
  {
    "name": "Gisbourne",
    "value": 1,
    "lat": -27.6621822,
    "lng": 153.0031321
  },
  {
    "name": "Glen Park",
    "value": 1,
    "lat": -37.507508,
    "lng": 143.9231129
  },
  {
    "name": "Glen Waverley",
    "value": 4,
    "lat": -37.8794953,
    "lng": 145.1622842
  },
  {
    "name": "Greensborough",
    "value": 2,
    "lat": -37.7037383,
    "lng": 145.10791052131128
  },
  {
    "name": "Greenvale",
    "value": 2,
    "lat": -37.62655075,
    "lng": 144.90003733868005
  },
  {
    "name": "Hampton Park",
    "value": 2,
    "lat": -38.0367368,
    "lng": 145.2590312
  },
  {
    "name": "Hastings",
    "value": 1,
    "lat": -38.3056058,
    "lng": 145.1859934
  },
  {
    "name": "Hawthorn",
    "value": 5,
    "lat": -37.8244246,
    "lng": 145.0317207
  },
  {
    "name": "Healesville",
    "value": 1,
    "lat": -37.6537218,
    "lng": 145.5161533
  },
  {
    "name": "Heatherton",
    "value": 1,
    "lat": -37.9560844,
    "lng": 145.0932067
  },
  {
    "name": "Heidelberg",
    "value": 1,
    "lat": -37.7524788,
    "lng": 145.0701284
  },
  {
    "name": "Heidelberg West",
    "value": 2,
    "lat": -37.7382431,
    "lng": 145.0433922
  },
  {
    "name": "Highton",
    "value": 3,
    "lat": -38.1709191,
    "lng": 144.3190212
  },
  {
    "name": "Hillside",
    "value": 1,
    "lat": -37.6904862,
    "lng": 144.7417358
  },
  {
    "name": "Hoppers Crossing",
    "value": 5,
    "lat": -37.870174,
    "lng": 144.69607084271246
  },
  {
    "name": "Horsham",
    "value": 1,
    "lat": -36.7148099,
    "lng": 142.2018105
  },
  {
    "name": "Inverloch",
    "value": 2,
    "lat": -38.6331582,
    "lng": 145.7279504
  },
  {
    "name": "Ivanhoe",
    "value": 4,
    "lat": -37.7688774,
    "lng": 145.0454487
  },
  {
    "name": "Kalkallo",
    "value": 3,
    "lat": -37.5309523,
    "lng": 144.9496539
  },
  {
    "name": "Kangaroo Flat",
    "value": 1,
    "lat": -36.806233000000006,
    "lng": 144.24078666059603
  },
  {
    "name": "Keilor East",
    "value": 2,
    "lat": -37.7295638,
    "lng": 144.7938135
  },
  {
    "name": "Keilor Park",
    "value": 1,
    "lat": -37.7187247,
    "lng": 144.8501721
  },
  {
    "name": "Kensington",
    "value": 1,
    "lat": -37.7939378,
    "lng": 144.9305645
  },
  {
    "name": "Kew",
    "value": 5,
    "lat": -37.8033586,
    "lng": 145.0333285
  },
  {
    "name": "Keysborough",
    "value": 2,
    "lat": -38.004856849999996,
    "lng": 145.16239832778558
  },
  {
    "name": "Kilmore",
    "value": 3,
    "lat": -37.2922688,
    "lng": 144.9510311
  },
  {
    "name": "Kinglake West",
    "value": 1,
    "lat": -37.450214,
    "lng": 145.258423
  },
  {
    "name": "Koo Wee Rup",
    "value": 1,
    "lat": -38.1990553,
    "lng": 145.492854
  },
  {
    "name": "Langwarrin",
    "value": 1,
    "lat": -38.1545829,
    "lng": 145.1973931
  },
  {
    "name": "Lara",
    "value": 1,
    "lat": -38.0235346,
    "lng": 144.4088294
  },
  {
    "name": "Laverton North",
    "value": 4,
    "lat": -37.84227635,
    "lng": 144.78835195840344
  },
  {
    "name": "Lilydale",
    "value": 2,
    "lat": -37.7571582,
    "lng": 145.34586560554067
  },
  {
    "name": "Little River",
    "value": 1,
    "lat": -37.9639273,
    "lng": 144.5009868
  },
  {
    "name": "Lower Plenty",
    "value": 3,
    "lat": -37.7388437,
    "lng": 145.116224
  },
  {
    "name": "MAIDSTONE",
    "value": 1,
    "lat": -37.7753803,
    "lng": 144.8748209
  },
  {
    "name": "MANOR LAKES",
    "value": 4,
    "lat": -37.8686285,
    "lng": 144.5950127
  },
  {
    "name": "MICKLEHAM",
    "value": 10,
    "lat": -37.5344793,
    "lng": 144.9120372
  },
  {
    "name": "Malvern",
    "value": 3,
    "lat": -37.8576088,
    "lng": 145.0350666
  },
  {
    "name": "Malvern East",
    "value": 2,
    "lat": -37.8768464,
    "lng": 145.0691723
  },
  {
    "name": "Mambourin",
    "value": 5,
    "lat": -37.8908261,
    "lng": 144.5947762
  },
  {
    "name": "Manifold Heights",
    "value": 1,
    "lat": -38.1374209,
    "lng": 144.3337974
  },
  {
    "name": "Mansfield",
    "value": 1,
    "lat": -37.0521177,
    "lng": 146.0881445
  },
  {
    "name": "Maryborough",
    "value": 1,
    "lat": -37.0467582,
    "lng": 143.7375721
  },
  {
    "name": "Melbourne",
    "value": 36,
    "lat": -37.8142454,
    "lng": 144.9631732
  },
  {
    "name": "Melbourne Airport",
    "value": 9,
    "lat": -37.6667554,
    "lng": 144.8288501411705
  },
  {
    "name": "Melton",
    "value": 3,
    "lat": -37.6835714,
    "lng": 144.5828446
  },
  {
    "name": "Melton South",
    "value": 1,
    "lat": -37.7060279,
    "lng": 144.5717723
  },
  {
    "name": "Merbein",
    "value": 1,
    "lat": -34.167621,
    "lng": 142.0581482
  },
  {
    "name": "Merebin",
    "value": 1,
    "lat": -34.1699715,
    "lng": 142.0769643
  },
  {
    "name": "Mernda",
    "value": 6,
    "lat": -37.6025021,
    "lng": 145.1009024
  },
  {
    "name": "Mitchell Park",
    "value": 1,
    "lat": -37.649650449999996,
    "lng": 147.3489915304714
  },
  {
    "name": "Moe",
    "value": 2,
    "lat": -38.177049,
    "lng": 146.2619888
  },
  {
    "name": "Moonee Ponds",
    "value": 8,
    "lat": -37.765935,
    "lng": 144.9192614
  },
  {
    "name": "Moorabbin",
    "value": 5,
    "lat": -37.97845745,
    "lng": 145.09835525579624
  },
  {
    "name": "Moorabbin Airport",
    "value": 1,
    "lat": -37.97845745,
    "lng": 145.09835525579624
  },
  {
    "name": "Mooroolbark",
    "value": 1,
    "lat": -37.784697,
    "lng": 145.3131856
  },
  {
    "name": "Mordialloc",
    "value": 6,
    "lat": -38.0067174,
    "lng": 145.0875658
  },
  {
    "name": "Mornington",
    "value": 1,
    "lat": -38.2202151,
    "lng": 145.0411089
  },
  {
    "name": "Morwell",
    "value": 6,
    "lat": -38.2363218,
    "lng": 146.3977575
  },
  {
    "name": "Mostly CBD",
    "value": 1,
    "lat": -37.7232173,
    "lng": 144.7513063
  },
  {
    "name": "Mount Duneed",
    "value": 5,
    "lat": -38.2316529,
    "lng": 144.3170763
  },
  {
    "name": "Mount Eliza",
    "value": 1,
    "lat": -38.19027015,
    "lng": 145.09246799372391
  },
  {
    "name": "Mount Martha",
    "value": 1,
    "lat": -38.2754676,
    "lng": 145.0307737
  },
  {
    "name": "Mount Waverely",
    "value": 1,
    "lat": -37.8653328,
    "lng": 145.1300742
  },
  {
    "name": "Mount Waverley",
    "value": 6,
    "lat": -37.8752637,
    "lng": 145.1281258
  },
  {
    "name": "Mulgrave",
    "value": 1,
    "lat": -37.9261741,
    "lng": 145.1723107
  },
  {
    "name": "NUNAWADING",
    "value": 1,
    "lat": -37.8204435,
    "lng": 145.1748409
  },
  {
    "name": "Nagambie",
    "value": 2,
    "lat": -36.7820441,
    "lng": 145.143609225
  },
  {
    "name": "Narre Warren",
    "value": 3,
    "lat": -38.0275167,
    "lng": 145.3037690879916
  },
  {
    "name": "Narre Warren North",
    "value": 1,
    "lat": -37.9813391,
    "lng": 145.3129016
  },
  {
    "name": "Newborough",
    "value": 2,
    "lat": -38.1850569,
    "lng": 146.2904653
  },
  {
    "name": "Newport",
    "value": 2,
    "lat": -37.8423064,
    "lng": 144.88356223970217
  },
  {
    "name": "Newtown",
    "value": 6,
    "lat": -38.1539124,
    "lng": 144.3350959
  },
  {
    "name": "Nilma",
    "value": 3,
    "lat": -38.1711312,
    "lng": 145.9672035
  },
  {
    "name": "Noble Park",
    "value": 1,
    "lat": -37.966459650000004,
    "lng": 145.176114726163
  },
  {
    "name": "North Ballarat",
    "value": 1,
    "lat": -37.5587442,
    "lng": 143.8593693
  },
  {
    "name": "North Geelong",
    "value": 1,
    "lat": -38.12239135,
    "lng": 144.3522479849335
  },
  {
    "name": "North Melbourne",
    "value": 7,
    "lat": -37.8076092,
    "lng": 144.9423514
  },
  {
    "name": "Oakleigh",
    "value": 1,
    "lat": -37.900392,
    "lng": 145.0883324
  },
  {
    "name": "Oakleigh South",
    "value": 1,
    "lat": -37.92321775,
    "lng": 145.09072898845199
  },
  {
    "name": "Officer",
    "value": 10,
    "lat": -38.0662897,
    "lng": 145.41169625320452
  },
  {
    "name": "POINT HENRY",
    "value": 1,
    "lat": -38.1256046,
    "lng": 144.425765
  },
  {
    "name": "Pakenham",
    "value": 1,
    "lat": -38.0806283,
    "lng": 145.4863217
  },
  {
    "name": "Parkdale",
    "value": 1,
    "lat": -37.9924751,
    "lng": 145.0755901
  },
  {
    "name": "Parkville",
    "value": 12,
    "lat": -37.7871148,
    "lng": 144.9515533
  },
  {
    "name": "Patterson Lakes",
    "value": 1,
    "lat": -38.0694493,
    "lng": 145.1432329
  },
  {
    "name": "Phillip Island",
    "value": 1,
    "lat": -38.50717805,
    "lng": 145.18881031587003
  },
  {
    "name": "Plumpton",
    "value": 2,
    "lat": -37.6727808,
    "lng": 144.6993618
  },
  {
    "name": "Point Cook",
    "value": 12,
    "lat": -37.9064862,
    "lng": 144.7533059
  },
  {
    "name": "Port Melbourne",
    "value": 7,
    "lat": -37.8333613,
    "lng": 144.9219203
  },
  {
    "name": "Port Melbourne.",
    "value": 2,
    "lat": -37.8333613,
    "lng": 144.9219203
  },
  {
    "name": "Portsea",
    "value": 1,
    "lat": -38.3228212,
    "lng": 144.7004208
  },
  {
    "name": "Prahran",
    "value": 4,
    "lat": -37.849953,
    "lng": 144.98981649178617
  },
  {
    "name": "Preston",
    "value": 2,
    "lat": -37.7395301,
    "lng": 145.0004919
  },
  {
    "name": "Richmond",
    "value": 13,
    "lat": -37.820386,
    "lng": 145.0025144
  },
  {
    "name": "Riddells Creek",
    "value": 1,
    "lat": -37.4649363,
    "lng": 144.6799996
  },
  {
    "name": "Ringwood",
    "value": 3,
    "lat": -37.8158726,
    "lng": 145.22911125106023
  },
  {
    "name": "Ringwood East",
    "value": 1,
    "lat": -37.8117518,
    "lng": 145.2499467
  },
  {
    "name": "Rippleside",
    "value": 1,
    "lat": -38.1234908,
    "lng": 144.3563619
  },
  {
    "name": "Rockbank",
    "value": 1,
    "lat": -37.7312767,
    "lng": 144.6607316
  },
  {
    "name": "Romsey",
    "value": 1,
    "lat": -37.3518801,
    "lng": 144.7374475
  },
  {
    "name": "Rosebud",
    "value": 4,
    "lat": -38.3710325,
    "lng": 144.9095115
  },
  {
    "name": "Roxburgh Park",
    "value": 1,
    "lat": -37.63815625,
    "lng": 144.93533017828446
  },
  {
    "name": "Sale",
    "value": 1,
    "lat": -38.1094463,
    "lng": 147.0656717
  },
  {
    "name": "Sandringham",
    "value": 1,
    "lat": -37.9502592,
    "lng": 145.0043868
  },
  {
    "name": "Seabrook",
    "value": 1,
    "lat": -37.8806797,
    "lng": 144.7578334
  },
  {
    "name": "Seaford",
    "value": 2,
    "lat": -38.1040134,
    "lng": 145.1282259
  },
  {
    "name": "Sebastopol",
    "value": 2,
    "lat": -37.588417250000006,
    "lng": 143.83464848170172
  },
  {
    "name": "Shepparton",
    "value": 1,
    "lat": -36.3831633,
    "lng": 145.3988874
  },
  {
    "name": "Shepparton North",
    "value": 1,
    "lat": -36.322336,
    "lng": 145.38870609524633
  },
  {
    "name": "Smythes Creek",
    "value": 1,
    "lat": -37.6028625,
    "lng": 143.76716295482177
  },
  {
    "name": "Somerton",
    "value": 9,
    "lat": -37.634688,
    "lng": 144.9507961
  },
  {
    "name": "Sorrento",
    "value": 4,
    "lat": -38.3447273,
    "lng": 144.7420938
  },
  {
    "name": "South Kingsville",
    "value": 1,
    "lat": -37.8306664,
    "lng": 144.8713429
  },
  {
    "name": "South Melbourne",
    "value": 3,
    "lat": -37.822925549999994,
    "lng": 144.96865622637097
  },
  {
    "name": "South Morang",
    "value": 1,
    "lat": -37.64924405,
    "lng": 145.0672450098665
  },
  {
    "name": "South Yarra",
    "value": 2,
    "lat": -37.8377695,
    "lng": 144.9918537
  },
  {
    "name": "South melbounre",
    "value": 2,
    "lat": -37.83344,
    "lng": 144.9570533
  },
  {
    "name": "Southbank",
    "value": 5,
    "lat": -37.8253618,
    "lng": 144.9640203
  },
  {
    "name": "Springvale",
    "value": 5,
    "lat": -37.9496947,
    "lng": 145.1539118
  },
  {
    "name": "St Albans",
    "value": 1,
    "lat": -37.74455605,
    "lng": 144.79968642559174
  },
  {
    "name": "St Kilda",
    "value": 3,
    "lat": -37.8638261,
    "lng": 144.981637
  },
  {
    "name": "St Leonards",
    "value": 1,
    "lat": -38.1707592,
    "lng": 144.7182761
  },
  {
    "name": "Strathmore",
    "value": 1,
    "lat": -37.7333202,
    "lng": 144.9182433
  },
  {
    "name": "Strathtulloh",
    "value": 1,
    "lat": -37.7324394,
    "lng": 144.5975017
  },
  {
    "name": "Streatham",
    "value": 1,
    "lat": -37.638257499999995,
    "lng": 143.09059909549632
  },
  {
    "name": "Sunbury",
    "value": 7,
    "lat": -37.5791363,
    "lng": 144.7279832
  },
  {
    "name": "Sunshine",
    "value": 3,
    "lat": -37.7887617,
    "lng": 144.8331303
  },
  {
    "name": "Sunshine North",
    "value": 1,
    "lat": -37.7639467,
    "lng": 144.8361969
  },
  {
    "name": "Sunshine West",
    "value": 14,
    "lat": -37.7854449,
    "lng": 144.7903402396812
  },
  {
    "name": "Surrey Hills",
    "value": 3,
    "lat": -37.8271881,
    "lng": 145.0978326
  },
  {
    "name": "Sydenham",
    "value": 1,
    "lat": -37.6997223,
    "lng": 144.7653295
  },
  {
    "name": "THORNHILL PARK",
    "value": 5,
    "lat": -37.7274099,
    "lng": 144.6259215
  },
  {
    "name": "Tarneit",
    "value": 13,
    "lat": -37.8321522,
    "lng": 144.69462
  },
  {
    "name": "Templestowe Lower",
    "value": 1,
    "lat": -37.7638749,
    "lng": 145.1122762
  },
  {
    "name": "Thomastown",
    "value": 4,
    "lat": -37.6832672,
    "lng": 145.0081104
  },
  {
    "name": "Thornbury",
    "value": 1,
    "lat": -37.7549944,
    "lng": 144.9985944
  },
  {
    "name": "Toorak",
    "value": 9,
    "lat": -37.850751,
    "lng": 145.013698902256
  },
  {
    "name": "Torquay",
    "value": 2,
    "lat": -38.3266551,
    "lng": 144.3134076
  },
  {
    "name": "Traralgon",
    "value": 1,
    "lat": -38.1946636,
    "lng": 146.5381646
  },
  {
    "name": "Truganina",
    "value": 8,
    "lat": -37.8089015,
    "lng": 144.721139
  },
  {
    "name": "Tullamarine",
    "value": 7,
    "lat": -37.704658,
    "lng": 144.8717732
  },
  {
    "name": "VARIOUS",
    "value": 2,
    "lat": -37.6555038,
    "lng": 145.0786704
  },
  {
    "name": "Vermont South",
    "value": 1,
    "lat": -37.854386,
    "lng": 145.1878065
  },
  {
    "name": "WANTIRNA SOUTH",
    "value": 1,
    "lat": -37.8737902,
    "lng": 145.2217475
  },
  {
    "name": "Wacol",
    "value": 1,
    "lat": -36.5986096,
    "lng": 144.6780052
  },
  {
    "name": "Wallan",
    "value": 2,
    "lat": -37.4168041,
    "lng": 145.0052646
  },
  {
    "name": "Wangaratta",
    "value": 2,
    "lat": -36.356434,
    "lng": 146.3228311
  },
  {
    "name": "Wantirna",
    "value": 3,
    "lat": -37.85591645,
    "lng": 145.23018292594725
  },
  {
    "name": "Waurn Ponds",
    "value": 2,
    "lat": -38.2158244,
    "lng": 144.3061193
  },
  {
    "name": "Weir Views",
    "value": 3,
    "lat": -37.7323715,
    "lng": 144.5708942
  },
  {
    "name": "Wendouree",
    "value": 1,
    "lat": -37.5501895,
    "lng": 143.83503056464738
  },
  {
    "name": "Werribee",
    "value": 18,
    "lat": -37.8995007,
    "lng": 144.6609036
  },
  {
    "name": "West Footscray",
    "value": 3,
    "lat": -37.80174125,
    "lng": 144.8840743363326
  },
  {
    "name": "West Meadows",
    "value": 1,
    "lat": -36.5523641,
    "lng": 145.9939817
  },
  {
    "name": "Whittlesea",
    "value": 1,
    "lat": -37.5507305,
    "lng": 145.0618809755639
  },
  {
    "name": "Williamstown",
    "value": 4,
    "lat": -37.8611788,
    "lng": 144.8898569
  },
  {
    "name": "Winchelsea",
    "value": 1,
    "lat": -38.2419077,
    "lng": 143.9859604
  },
  {
    "name": "Windsor",
    "value": 2,
    "lat": -37.85582435,
    "lng": 144.9916848077674
  },
  {
    "name": "Wollert",
    "value": 19,
    "lat": -37.5939889,
    "lng": 145.0337333
  },
  {
    "name": "Wyndham Vale",
    "value": 1,
    "lat": -37.8722432,
    "lng": 144.6084185
  },
  {
    "name": "YUROKE",
    "value": 1,
    "lat": -37.5894631,
    "lng": 144.8789803
  },
  {
    "name": "Yarra Glen",
    "value": 1,
    "lat": -37.6573475,
    "lng": 145.3743964
  },
  {
    "name": "Yarragon",
    "value": 1,
    "lat": -38.186209000000005,
    "lng": 146.0859832618223
  },
  {
    "name": "Yarrambat",
    "value": 1,
    "lat": -37.6375473,
    "lng": 145.1349293
  },
  {
    "name": "Yarraville",
    "value": 3,
    "lat": -37.81574515,
    "lng": 144.88996772207105
  },
  {
    "name": "melb",
    "value": 1,
    "lat": -37.8229117,
    "lng": 144.9686548
  }
];
